var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showType == 'form-builder')?_c('b-form-group',{style:(_vm.properties.style),attrs:{"description":_vm.properties.description,"label":_vm.properties.label}},[_c('phone-input',{attrs:{"defaultCountry":" ","placeholder":_vm.properties.placeholder}})],1):_vm._e(),(_vm.showType == 'properties')?_c('div',[_c('phone-input-v1-properties',{attrs:{"formId":_vm.formId}})],1):_vm._e(),(
      _vm.showType == 'form-submitter' ||
        (_vm.showType == 'e-form' && _vm.properties.eFormEditable)
    )?_c('b-form-group',{staticStyle:{"font-size":"14px"},style:(_vm.properties.style),attrs:{"description":_vm.computedConditions.description
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'description',
            value: _vm.properties.description,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.description,"label":_vm.computedConditions.label
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'label',
            value: _vm.properties.label,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.label,"hidden":_vm.computedHidden,"state":_vm.state,"invalid-feedback":_vm.errors.join(', ')}},[_c('phone-input',{staticStyle:{"font-size":"14px"},attrs:{"placeholder":_vm.computedConditions.placeholder
          ? _vm.superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'placeholder',
              value: _vm.properties.placeholder,
              defaultValue: '',
              form: this.form
            })
          : _vm.properties.placeholder,"readonly":_vm.computedConditions.readonly
          ? _vm.superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'readonly',
              value: _vm.properties.readonly,
              defaultValue: false,
              form: this.form
            })
          : _vm.properties.readonly,"required":_vm.computedConditions.required
          ? _vm.superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'required',
              value: _vm.properties.required,
              defaultValue: false,
              form: this.form
            })
          : _vm.properties.required,"state":_vm.state,"defaultCountry":" "},on:{"blur":function($event){_vm.controlValue = _vm.localValue}},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1):_vm._e(),(
      _vm.showType == 'form-viewer' ||
        (_vm.showType == 'e-form' && !_vm.properties.eFormEditable)
    )?_c('b-form-group',{attrs:{"label":_vm.computedConditions.label
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'label',
            value: _vm.properties.label,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.label}},[_vm._v(" "+_vm._s(_vm.localValue)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }